import { VueInstance } from '@vueuse/core'
import { Component, computed, ref } from 'vue'

export type ExtractComponentProps<T> = T extends new () => { $props: infer P }
  ? P
  : any;

type CompIns<T extends Component, P = ExtractComponentProps<T>> = {
  comp: T;
  props: P;
  visible: boolean;
  key: string;
  ref: VueInstance;
  once: boolean;
};

const comps = ref<Map<Component, CompIns<any>>>(new Map())

export const useComps = () => {
  return computed(() => {
    console.log('render')
    return comps.value.values()
  })
}

export const useComp = <T extends Component>({
  comp,
  props
}: Pick<CompIns<T>, 'comp'|'props'>) => {
  const ins = comps.value.get(comp!)
  if (!ins) {
    comps.value.set(comp!, {
      comp,
      props,
      visible: true,
      key: Math.random().toString(),
      ref: null as any,
      once: false
    })
  } else {
    ins.visible = true
    ins.props = props
    comps.value.set(comp, { ...ins })
  }
}
